import React from 'react';
import { Slide, ToastContainer } from 'react-toastify';

const containerConfig = { limit: 5 };

const ToastsContainerComponent = () => <ToastContainer {...containerConfig} transition={Slide} />;

export default ToastsContainerComponent;
